import {
  Container,
  Mesh,
  mat4,
  vec3,
  vec4,
  Program,
  IcoSphereGeometryBuffer
} from 'beam'
import CubicBezier from './helpers/cubicBezier'
import Box from './Box'
import maskColors from './maskColors'
import getPosition from './helpers/getPosition'
import Tween from './helpers/Tween'
import gridVertexShader from './shaders/grid-vs.glsl'
import gridFragmentShader from './shaders/grid-fs.glsl'

import Emitter from '../core/emitter.js'
import WheelIndicator from 'wheel-indicator'
import SwipeIndicator from './helpers/swipe-indicator'
import support from './helpers/support'

const MAX_SLIDES_PER_COLLECTION = 14

export default class GLPortfolio extends HTMLElement {
  constructor() {
    super()

    this.onCaseEnter = this.onCaseEnter.bind(this)
    this.onCaseLeave = this.onCaseLeave.bind(this)

    this.resize = this.resize.bind(this)
    this.update = this.update.bind(this)
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerUp = this.onPointerUp.bind(this)
    this._onMouseWheel = this._onMouseWheel(this)
    this._progress = 0
    this._progressDown = 0
    this._pointerDown = 0
    this._top = 0

    this.onImmersiveView = this.onImmersiveView.bind(this)
    this.onwheel = this.onwheel.bind(this)
    this.currStep = 0

    this.zoomOffsetZ = 0
    this.$links = []

    this.enterScale = 0
    this._wheelValue = 0
    this.leaveScale = 0

    this.numSlidesPerCollection = 14
  }

  onCaseEnter(e) {
    if (this.isDragging) return
    const collIndex = Number(
      e.currentTarget.getAttribute('data-collection-index')
    )
    const caseIndex = Number(e.currentTarget.getAttribute('data-case-index'))
    this.collections[collIndex].cases[caseIndex].boxScaleMultiplier = 0.3
    if (this.collections[collIndex].cases[caseIndex].$caseInfos) {
      this.collections[collIndex].cases[caseIndex].$caseInfos.classList.add(
        'is-active'
      )
    }
    this.$title.classList.remove('is-active')
    this.$cta.classList.remove('is-active')
  }

  onCaseLeave(e) {
    const collIndex = Number(
      e.currentTarget.getAttribute('data-collection-index')
    )
    const caseIndex = Number(e.currentTarget.getAttribute('data-case-index'))
    this.collections[collIndex].cases[caseIndex].boxScaleMultiplier = 0
    if (this.collections[collIndex].cases[caseIndex].$caseInfos) {
      this.collections[collIndex].cases[caseIndex].$caseInfos.classList.remove(
        'is-active'
      )
    }
    this.$title.classList.add('is-active')
    this.$cta.classList.add('is-active')
  }

  connectedCallback() {
    this.__isConnected__ = true
    this._wheel = 0
    window.addEventListener('resize', this.resize)
    document.addEventListener('resize', this.resize)
    this.resizeObserver = new ResizeObserver(this.resize)
    this.resizeObserver.observe(this)
    this.resizeObserver.observe(document.body)

    this.addEventListener('mousedown', this.onPointerDown)
    this.addEventListener('touchstart', this.onPointerDown, { passive: false })

    let node = this
    let i = 0
    while (node.parentNode && i < 100) {
      if (node.parentNode.tagName == 'WEBGL-SCENE') {
        this.$glScene = node.parentNode
        break
      }
      node = node.parentNode
      i++
    }

    if (!this.$glScene) {
      console.warn('missing webgl scene !')
      return
    }

    requestAnimationFrame(() => {
      this.init()
      this.update()
      Emitter.on('immersive-view', this.onImmersiveView)
    })
  }

  onImmersiveView(isImmersiveMode) {
    if (isImmersiveMode) {
      this.show()
    } else {
      this.hide()
    }
  }

  _onMouseWheel(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var wheelDeltaX, wheelDeltaY
    if (e.wheelDelta) {
      wheelDeltaX = wheelDeltaY = e.wheelDelta //6 or 12
    } else if (e.detail) {
      wheelDeltaX = wheelDeltaY = -e.detail * 40 // *3
    } else if (e.wheelDeltaX) {
      wheelDeltaY = e.wheelDeltaY / 12
      wheelDeltaX = (-1 * e.wheelDeltaX) / 12
    } else if (e.axis !== undefined && e.axis === e.HORIZONTAL_AXIS) {
      wheelDeltaY = 0
      wheelDeltaX = -1 * wheelDeltaY
    } else {
      wheelDeltaY = 0
      wheelDeltaX = 0
    }
    this._wheelValue += (wheelDeltaY || 0) * -1 //0.001;
  }

  show() {
    console.log('SHOW PORTFOLIO')
    this.leaveScale = 0
    this.enterScale = 0
    this.reset()
    this.leaveScale = 0
    this.enterScale = 0
    Tween(
      { e: 0 },
      {
        to: { e: 1 },
        delay: 0,
        easing: [0.43, 0.195, 0.02, 1.0],
        duration: 1,
        step: (e) => {
          this.enterScale = e
        },
        end: () => {}
      }
    )
  }

  hide() {
    console.log('HIDe PORTFOLIO')
    this.enterScale = 1
    this.leaveScale = 0
    Tween(
      { e: 0 },
      {
        to: { e: 1 },
        delay: 0,
        easing: [0.43, 0.195, 0.02, 1.0],
        duration: 1,
        step: (e) => {
          this.enterScale = 1 - e
          this.leaveScale = e * 2
        },
        end: () => {}
      }
    )
  }

  onwheel(e) {
    if (Date.now() - this.lastWheel < 700) {
      return
    }

    this.lastWheel = Date.now()

    let lastStep = this.currStep
    this.currStep += e.direction == 'down' ? 1 : -1

    this.currStep = Math.max(0, this.currStep)
    // this.currStep = Math.min(this.collections.length-1, this.currStep);

    this.collections.forEach((collection, j) => {
      collection.offset = collection.offset || 0
      if (e.direction == 'down') {
        if (j - this.currStep + collection.offset < -1) {
          collection.offset += this.collections.length
          collection.cases.forEach((box, i) => {
            box.container.scale[0] = 0
            box.container.scale[1] = 0
            box.container.scale[2] = 0
          })
        }
      } else {
        if (j - this.currStep + collection.offset > 1) {
          collection.offset -= this.collections.length
          collection.cases.forEach((box, i) => {
            box.container.scale[0] = 0
            box.container.scale[1] = 0
            box.container.scale[2] = 0
          })
        }
      }
    })

    let start = lastStep * window.innerHeight * 3
    let end = this.currStep * window.innerHeight * 3

    Tween(
      { e: 0 },
      {
        to: { e: 1 },
        delay: 0,
        easing: [0.85, 0.025, 0.145, 0.975],
        duration: 1.8,
        step: (e) => {
          this.zoomOffsetZ = start + e * (end - start)
        }
      }
    )
  }

  init() {
    this.data = {
      slides: this.hasAttribute('data-slides')
        ? JSON.parse(this.getAttribute('data-slides'))
        : []
    }

    if (this.hasAttribute('use-wheel')) {
      this._wheelIndicator = new WheelIndicator({
        elem: this,
        preventMouse: !window.acf,
        callback: this.onwheel
      })
      if (support.touch) {
        this._swipeIndicator = new SwipeIndicator({
          elem: document,
          callback: this.onwheel,
          preventMouse: !window.wp,
          direction: 'y'
        })
      }
      this.numSlidesPerCollection = MAX_SLIDES_PER_COLLECTION
    } else {
      this.numSlidesPerCollection = Math.min(
        MAX_SLIDES_PER_COLLECTION,
        this.data.slides.length
      )
    }

    this.renderer = this.$glScene.renderer

    this.casesContainer = new Container()
    this.$glScene.addChild(this.casesContainer)

    this.collections = []

    this.numLayers = Math.ceil(
      this.data.slides.length / this.numSlidesPerCollection
    )

    this.$previewButtons = this.querySelectorAll('[data-preview-button]')
    this.$caseInfos = this.querySelectorAll('[data-featured-infos]')
    this.$title = this.querySelector('[data-featured-title]')
    this.$cta = this.querySelector('[data-featured-cta]')

    for (let j = 0; j < this.numLayers; j++) {
      const cases = []
      for (let i = 0; i < this.numSlidesPerCollection; i++) {
        const box = new Box(this.renderer, {
          src: this.data.slides[
            (j * this.numSlidesPerCollection + i) % this.data.slides.length
          ].raw_image
            ? this.data.slides[
                (j * this.numSlidesPerCollection + i) % this.data.slides.length
              ].raw_image.sizes['1536x1536']
            : `/wp-content/themes/wp-base-theme/dist/assets/textures/${
                ((j * this.numSlidesPerCollection + i) % 5) + 1
              }.jpg`,
          maskChanel: maskColors[i % maskColors.length],
          boxScale: 0.1
        })
        box.container.scale[0] = 0
        box.container.scale[1] = 0
        box.container.scale[2] = 0
        box.container.position[0] = window.innerWidth * 0.2 * i
        box.container.position[1] = 0
        box.container.position[2] = 0
        box.rand = Math.random()
        box.rand2 = Math.random()

        const caseIndex = cases.length
        cases.push(box)
        this.casesContainer.add(box.container)
        this.$glScene.registerBox(box)

        box.el = document.createElement('a')
        box.el.setAttribute(
          'href',
          this.data.slides[
            (j * this.numSlidesPerCollection + i) % this.data.slides.length
          ].link
        )
        box.el.classList.add('disable-when-dragging')
        box.el.innerHTML = `<span class="btn-primary ">Explore Case</span>`
        box.el.style.display = 'flex'
        box.el.style.alignItems = 'center'
        box.el.style.justifyContent = 'center'
        box.el.style.position = 'fixed'
        box.el.style.zIndex = 999
        box.el.style.top = 0
        box.el.style.left = 0
        box.el.style.opacity = 0
        box.el.style.padding = '100px'
        box.el.setAttribute('data-case-index', caseIndex)
        box.el.setAttribute('data-collection-index', j)
        box.el.addEventListener('mouseenter', this.onCaseEnter)
        box.el.addEventListener('mouseleave', this.onCaseLeave)

        this.appendChild(box.el)
        if (this.$previewButtons[j * this.numSlidesPerCollection + i]) {
          box.$btn =
            this.$previewButtons[
              (j * this.numSlidesPerCollection + i) %
                this.$previewButtons.length
            ]
          box.$btn.addEventListener('click', (e) => {
            const step = (Math.PI * 2) / this.numSlidesPerCollection
            this._progress =
              ((step * caseIndex + step * -1) / (Math.PI * -2)) *
              window.innerWidth
          })

          box.$caseInfos = this.$caseInfos[j * this.numSlidesPerCollection + i]
        }
      }

      const icoSphere = new Mesh()
      icoSphere.geometry = new IcoSphereGeometryBuffer(this.renderer.gl, {
        radius: 2500,
        details: 6
      })
      icoSphere.material = new Program(this.renderer.gl, {
        vertexShader: gridVertexShader,
        fragmentShader: gridFragmentShader,
        type: this.renderer.gl.POINTS,
        uniforms: {
          uPointScale: 1,
          uInfiniteGrid: 0
        }
      })
      this.casesContainer.add(icoSphere)
      this.collections.push({ cases, icoSphere })
    }
  }

  onPointerDown(e) {
    this._pointerDown = e.touches ? e.touches[0].pageX : e.pageX
    this._progressDown = this._progress
    document.addEventListener('mousemove', this.onPointerMove)
    document.addEventListener('touchmove', this.onPointerMove, {
      passive: false
    })

    document.addEventListener('mouseup', this.onPointerUp)
    document.addEventListener('touchend', this.onPointerUp, { passive: false })
  }

  onPointerMove(e) {
    this.classList.add('is-dragging')
    this.isDragging = true
    this._progress =
      this._progressDown +
      ((e.touches ? e.touches[0].pageX : e.pageX) - this._pointerDown)
  }

  onPointerUp(e) {
    this.classList.remove('is-dragging')
    this.isDragging = false
    document.removeEventListener('mousemove', this.onPointerMove)
    document.removeEventListener('touchmove', this.onPointerMove, {
      passive: false
    })
    document.removeEventListener('mouseup', this.onPointerUp)
    document.removeEventListener('touchend', this.onPointerUp, {
      passive: false
    })
  }

  disconnectedCallback() {
    this.__isConnected__ = false
    this.$glScene.removeChild(this.casesContainer)
    window.removeEventListener('resize', this.resize)
    Emitter.off('immersive-view', this.onImmersiveView)
    this.resizeObserver.unobserve(this)
    this.resizeObserver.unobserve(document.body)
    this._swipeIndicator?.turnOff()
    this._wheelIndicator?.turnOff()

    this.collections?.forEach((collection, j) => {
      collection.cases.forEach((box, i) => {
        box.el.removeEventListener('mouseenter', this.onCaseEnter)
        box.el.removeEventListener('mouseleave', this.onCaseLeave)
      })
    })
  }

  resize() {
    this._top = getPosition(this).top
  }

  reset() {
    let prtfolioEnterProgress = Math.max(
      0,
      Math.min(
        1,
        (this.$glScene._scroll - (this._top - window.innerHeight * 1)) /
          (window.innerHeight * 1)
      )
    )
    let prtfolioLeaveProgress = Math.max(
      0,
      Math.min(
        1,
        (this.$glScene._scroll - (this._top - window.innerHeight * 0)) /
          (window.innerHeight * 1)
      )
    )

    if (this._top == 0) {
      prtfolioEnterProgress = this.enterScale
      prtfolioLeaveProgress = this.leaveScale
    }

    this.collections?.forEach((collection, j) => {
      collection.cases.forEach((box, i) => {
        const step = (Math.PI * 2) / this.numSlidesPerCollection
        box.boxScale = (window.innerHeight / 100) * 0.1
        box.container.scale[0] +=
          ((window.innerHeight / 100) *
            0.1 *
            (1 + (box.boxScaleMultiplier || 0)) *
            prtfolioEnterProgress -
            box.container.scale[0]) *
          1
        box.container.scale[1] +=
          ((window.innerHeight / 100) *
            0.1 *
            (1 + (box.boxScaleMultiplier || 0)) *
            prtfolioEnterProgress -
            box.container.scale[1]) *
          1
        box.container.scale[2] +=
          ((window.innerHeight / 100) *
            0.1 *
            (1 + (box.boxScaleMultiplier || 0)) *
            prtfolioEnterProgress -
            box.container.scale[2]) *
          1
        box.currPos = box.currPos || 0
        box.currPos +=
          (-0.5 +
            step * i -
            this.$glScene.userRotationY +
            (prtfolioEnterProgress * -Math.PI) / 2 +
            (prtfolioLeaveProgress * -Math.PI) / 2 -
            box.currPos) *
          1
        box.container.position[0] =
          Math.cos(box.currPos) *
          (this.$glScene._cameraZ * 0.4 +
            (i % 2 == 3 ? 0 : 1) * 400 +
            (i % 2 == 2 ? 0 : 1) * -200)
        box.container.position[2] =
          Math.sin(box.currPos) *
          (this.$glScene._cameraZ * 0.4 +
            (i % 2 == 3 ? 0 : 1) * 400 +
            (i % 2 == 2 ? 0 : 1) * -200)
      })
    })
  }

  update() {
    if (!this.__isConnected__) {
      return
    }

    requestAnimationFrame(() => {
      this.update()
    })

    if (!this.$glScene) {
      return
    }

    if (this.$glScene) {
      this.$glScene.rotateCameraY(
        (this._progress / window.innerWidth) * Math.PI * -2
      )
    }

    this.currZoomOffsetZ = this.currZoomOffsetZ || 0
    this.currZoomOffsetZ += (this.zoomOffsetZ - this.currZoomOffsetZ) * 0.1

    this.casesContainer.position[2] =
      this.$glScene.camera.position[2] + this.currZoomOffsetZ
    this.casesContainer.updateMatrix()
    this.casesContainer.updateWorldMatrix()

    let prtfolioEnterProgress = Math.max(
      0,
      Math.min(
        1,
        (this.$glScene._scroll - (this._top - window.innerHeight * 0.5)) /
          (window.innerHeight * 0.5)
      )
    )
    let prtfolioLeaveProgress = Math.max(
      0,
      Math.min(
        1,
        (this.$glScene._scroll - (this._top + window.innerHeight * 0.25)) /
          (window.innerHeight * 0.5)
      )
    )

    let easedEnterProgress = CubicBezier(
      0.775,
      0.065,
      0.345,
      0.88,
      prtfolioEnterProgress,
      1
    )
    let easedLeaveProgress = CubicBezier(
      0.775,
      0.065,
      0.345,
      0.88,
      prtfolioLeaveProgress,
      1
    )

    if (this._top == 0) {
      easedEnterProgress = this.enterScale
      easedLeaveProgress = this.leaveScale
    }

    this._viewMatrix = this._viewMatrix || mat4.create()
    mat4.copy(this._viewMatrix, this.$glScene.camera.inverseWorldMatrix)

    this.collections.forEach((collection, j) => {
      collection.offset = collection.offset || 0

      const layerProgress = Math.min(
        1,
        Math.max(
          0,
          (this.currZoomOffsetZ +
            window.innerHeight * 2 -
            (j + collection.offset) * window.innerHeight * 3) /
            (window.innerHeight * 3)
        )
      )

      collection.icoSphere.material.uniforms.uPointScale.value =
        easedEnterProgress * layerProgress * (1 - easedLeaveProgress)
      collection.icoSphere.position[2] =
        (j + collection.offset) * -(window.innerHeight * 3)
      collection.icoSphere.rotation[1] +=
        (this.$glScene.userRotationY +
          (easedEnterProgress * Math.PI) / 4 +
          (easedLeaveProgress * Math.PI) / 4 -
          collection.icoSphere.rotation[1]) *
        0.05
      collection.icoSphere.updateMatrix()
      collection.icoSphere.updateWorldMatrix()

      collection.cases.forEach((box, i) => {
        const step = (Math.PI * 2) / this.numSlidesPerCollection

        box.currBoxScaleMultiplier = box.currBoxScaleMultiplier || 0
        box.currBoxScaleMultiplier +=
          ((box.boxScaleMultiplier || 0) - box.currBoxScaleMultiplier) * 0.1

        box.container.scale[0] +=
          ((window.innerHeight / 100) *
            0.1 *
            easedEnterProgress *
            layerProgress *
            (1 - easedLeaveProgress) *
            (1 + box.currBoxScaleMultiplier) -
            box.container.scale[0]) *
          0.1
        box.container.scale[1] +=
          ((window.innerHeight / 100) *
            0.1 *
            easedEnterProgress *
            layerProgress *
            (1 - easedLeaveProgress) *
            (1 + box.currBoxScaleMultiplier) -
            box.container.scale[1]) *
          0.1
        box.container.scale[2] +=
          ((window.innerHeight / 100) *
            0.1 *
            easedEnterProgress *
            layerProgress *
            (1 - easedLeaveProgress) *
            (1 + box.currBoxScaleMultiplier) -
            box.container.scale[2]) *
          0.1

        box.currPos = box.currPos || 0
        box.currPos +=
          (-0.5 +
            step * (i - j * 2) -
            this.$glScene.userRotationY +
            (easedEnterProgress * -Math.PI) / 4 +
            (easedLeaveProgress * -Math.PI) / 4 -
            box.currPos) *
          0.05

        box.container.position[0] =
          Math.cos(box.currPos) *
          (this.$glScene._cameraZ * 0.5 + (i % 2 == 2 ? 0 : 1) * -100)
        box.container.position[2] =
          Math.sin(box.currPos) *
            (this.$glScene._cameraZ * 0.5 + (i % 2 == 2 ? 0 : 1) * -100) +
          (j + collection.offset) * -(window.innerHeight * 3)

        box.container.position[1] =
          (i % 2 == 0 ? -1 : 2) * window.innerHeight * 0.04 +
          (i % 3 == 0 ? -0.5 : 0.5) * window.innerHeight * 0.04
        box.container.rotation[1] =
          -Math.PI / 2 + box.currPos * -1 + (i % 3 == 0 ? -0.5 : 0.5) * 0.3
        box.container.updateMatrix()
        box.container.updateWorldMatrix()

        box._boxCenter = box._boxCenter || vec4.create()
        box._modelViewMatrix = box._modelViewMatrix || mat4.create()
        mat4.multiply(
          box._modelViewMatrix,
          this.$glScene.camera.inverseWorldMatrix,
          this.casesContainer.worldMatrix
        )
        vec4.set(
          box._boxCenter,
          box.container.position[0],
          box.container.position[1],
          box.container.position[2],
          1
        )
        vec4.transformMat4(box._boxCenter, box._boxCenter, box._modelViewMatrix)
        vec4.set(
          box._boxCenter,
          box._boxCenter[0],
          box._boxCenter[1],
          box._boxCenter[2],
          1
        )
        vec4.transformMat4(
          box._boxCenter,
          box._boxCenter,
          this.$glScene.camera.projectionMatrix
        )

        if (
          box._boxCenter[3] > 0 &&
          easedEnterProgress * layerProgress * (1 - easedLeaveProgress) > 0
        ) {
          box._boxCenter[0] /= box._boxCenter[3]
          box._boxCenter[1] /= box._boxCenter[3]
          box._boxCenter[0] =
            (box._boxCenter[0] * 0.5 + 0.5) * window.innerWidth
          box._boxCenter[1] =
            (-(box._boxCenter[1] * 0.5) + 0.5) * window.innerHeight
          box.el.style.transform = `translate(${box._boxCenter[0]}px, ${box._boxCenter[1]}px) translate(-50%, -50%) translateZ(0)`
          box.el.style.opacity =
            easedEnterProgress * layerProgress * (1 - easedLeaveProgress)
          box.el.style.pointerEvents = 'auto'

          if (box.$btn) {
            box.$btn.classList.toggle(
              'is-active',
              box._boxCenter[0] > 0 && box._boxCenter[0] < window.innerWidth
            )
          }
        } else {
          box.el.style.transform = `translate(-100%,-100%) translateZ(0)`
          box.el.style.opacity = 0
          box.el.style.pointerEvents = 'none'
          if (box.$btn) {
            box.$btn.classList.remove('is-active')
          }
        }
      })
    })
  }
}

customElements.define('gl-portfolio', GLPortfolio)
